import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { ClientCompletedProject } from 'src/app/model/project/client-completed-project';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import { ClientCompanySelectService } from 'src/app/services/client-company-select.service';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import { ClientCompletedSubProject } from '../../../../model/project/client-completed-sub-project';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';

@Component({
  selector: 'client-corner-completed-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['../abstract-immo-overview.component.scss'],
})
export class ClientCornerCompletedOverviewComponent extends AbstractImmoOverviewComponent<ClientCompletedSubProject> {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private clientCompanySelectService: ClientCompanySelectService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'projectPlacement__address',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentExecutionDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router,
      true
    );
  }

  public openTour(subProject: ClientCompletedSubProject): void {
    throw new Error('Method not implemented.');
  }
  public copyProjectId(subProject: ClientCompletedSubProject): void {
    throw new Error('Method not implemented.');
  }

  protected getPaginator(): MatPaginator {
    return this.paginator;
  }

  // Override
  protected initializePageSize(localStoredPageSize: number): void {
    this.getPaginator().pageSize =
      localStoredPageSize != null ? localStoredPageSize : 30;
  }

  protected initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'execution',
      'requestor',
      'address',
      'kindMultipleProducts',
      'measurementsMultipleProducts',
      'typeMultipleProducts',
      'requestAdjustmentButtons',
      'photoMultiple',
      'displayStatus',
    ];
  }
  protected initSortSettings(): void {
    this.sortColumn = 'project.id';
    this.sortAscending = false;
  }
  protected fetchItems(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getClientCompleted(
        this.clientCompanySelectService.getSelectedCompanyId(),
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.items = res.items;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public openProject(subProject: ClientCompletedSubProject): void {
    this.router.navigateByUrl(
      `/klant-opdracht/${subProject.project.id}/${subProject.id}`
    );
  }

  public requestSoldRented(project: ClientCompletedProject): void {
    this.router.navigateByUrl(
      `/klant-opdracht-verkocht-verhuurd/${project.id}`
    );
  }

  public requestAdjustment(project: ClientCompletedProject): void {
    this.router.navigateByUrl(`/klant-opdracht-aanpassing/${project.id}`);
  }

  public requestRepo(project: ClientCompletedProject): void {
    this.router.navigateByUrl(`/klant-opdracht-weghalen/${project.id}`);
  }

  protected getLocalStorageKey(): string {
    return 'ClientCornerCompletedOverviewComponent';
  }
}
